import { applyTopBarVars } from '@puzzlemania/blockjam';
import { blockJamConfig } from './blockjamManifest';

/**
 * Module 54 (WP-54.3) — publish Block Jam's Top Bar chrome as `--bj-topbar-*`
 * custom properties on the document root.
 *
 * This is the DOM half of the config seam. `games/blockjam/config/topbar-visuals.json`
 * reaches the bundle through `virtual:blockjam-config`, is validated by
 * `blockjamConfig.ts` (falling back to the in-bundle default), and lands here as
 * the four properties `.app-top-bar.bj-topbar` consumes.
 *
 * ## Why here, and why before render
 *
 * Both entries — the main site and the CrazyGames embed — call this, so all
 * platform profiles paint the bar from ONE answer rather than from whichever
 * stylesheet their bundler happened to concatenate last. It must run before
 * `ReactDOM.createRoot(...).render(...)`, because the stylesheet declares the
 * four properties with no fallback (deliberately — a fallback is a second copy
 * of the shipped look), so a bar that painted before them would paint nothing.
 * `topbar-boot.test.ts` holds both halves of that: called by both entries, and
 * called before render.
 *
 * The config is build-time constant, so this is a one-shot write at boot. The
 * Studio's live tuning does NOT come through here — it applies the same strings
 * to its own scoped preview container (WP-54.5), so tuning never restyles the
 * Studio's chrome or the Play tab.
 */
export function installBlockJamTopBarVars(root: HTMLElement = document.documentElement): void {
  applyTopBarVars(blockJamConfig.topbarVisuals, root);
}
